export default __webpack_public_path__ + "static/media/favicon.f160ed87.ico";